import {
  isAlipayMiniProgram,
  isDouYinMiniProgram,
  isWxMiniProgram,
  isXlH5,
} from './platforms';
import { loadScript } from '@/utils/tools';

const WX_OPEN_JS =
  'https://van-static.xlcx.cn/xl-static/56822/script/jweixin-1.3.2.js';
const ALIPAY_OPEN_JS = 'https://appx/web-view.min.js';
const DOUYIN_OPEN_JS =
  'https://van-static.xlcx.cn/xl-static/76039/script/douyin-webview-1.1.0.js';

// 调用小程序、H5返回上一页
export function mpNavigateBack() {
  if (isXlH5()) {
    window.history.back();
    return;
  }

  if (isAlipayMiniProgram()) {
    loadScript(ALIPAY_OPEN_JS, () => {
      if (!window.my) {
        return;
      }
      window.my.navigateBack();
    });
    return;
  }

  if (isDouYinMiniProgram()) {
    loadScript(DOUYIN_OPEN_JS, () => {
      if (!window.tt) return;
      window.tt.miniProgram.navigateBack();
    });
    return;
  }

  loadScript(WX_OPEN_JS, () => {
    if (!window.wx) return;
    window.wx.miniProgram.navigateBack();
  });
}

// 是否是各种小程序（把H5也算在内，反正都是调用 jssdk 的方法，已经一并兼容了
export function isMiniProgram() {
  return (
    isWxMiniProgram() ||
    isAlipayMiniProgram() ||
    isDouYinMiniProgram() ||
    isXlH5()
  );
}

// 发送消息
export function mpPostMessage(data, cb) {
  if (isXlH5()) {
    window.top.postMessage(
      {
        detail: {
          data,
        },
      },
      '*',
    );
    typeof cb === 'function' && cb();
    return;
  }

  if (isAlipayMiniProgram()) {
    loadScript(ALIPAY_OPEN_JS, () => {
      if (!window.my) {
        return;
      }
      window.my.postMessage({
        data,
      });

      typeof cb === 'function' && cb();
    });
    return;
  }

  if (isDouYinMiniProgram()) {
    loadScript(DOUYIN_OPEN_JS, () => {
      if (!window.tt) {
        return;
      }
      window.tt.miniProgram.postMessage({
        data,
      });
      typeof cb === 'function' && cb();
    });
    return;
  }

  loadScript(WX_OPEN_JS, () => {
    if (!window.wx) return;
    window.wx.miniProgram.postMessage({
      data,
    });
    typeof cb === 'function' && cb();
  });
  return;
}

/**
 * throttle，函数节流，有节流阀的意思，节约触发的频率。
 * 开发适用：微信小程序原生开发。
 * 场景适用：滚动条频繁触发、防止按钮重复点击等。
 */
export function throttle(fn, interval = 1000, callback) {
  let enterTime = 0 // 触发的时间

  return function() {
    const context = this
    const backTime = +new Date() // 第一次函数return即触发的时间 单位 ms

    if (backTime - enterTime > interval) {
      fn.call(context, ...arguments)
      enterTime = backTime // 赋值给第一次触发的时间，这样就保存了第二次触发的时间
    } else {
      // 新增频繁点击回调
      callback && callback.call(context, ...arguments)
    }
  }
}

/**
 * debounce，函数防抖，有防反跳的意思，防止重复触发。
 * 开发适用：微信小程序原生开发。
 * 场景适用：输入框匹配内容，滚动条滚动结束才触发等。
 */
export function debounce(fn, interval = 1000) {
  let timer = null

  return function() {
    clearTimeout(timer)
    const context = this
    const args = [...arguments] // 保存此处的arguments，因为setTimeout是全局的，arguments不是防抖函数需要的。
    timer = setTimeout(() => {
      fn.call(context, ...args)
      clearTimeout(timer)
    }, interval)
  }
}
